import React, { useEffect, useState } from "react";
import { Product, BumpProduct, Theme } from "./shared/types";
import { storeMarketingParamsOnLoad } from "./utils/queryParams";

import OrderForm from "./components/OrderForm"; // Import new component
import OrderFormSkeleton from "./components/skeleton/OrderFormSkeleton";

export interface AppProps {
  id: string;
}

interface FetchedData {
  theme?: Theme;
  productDisplayType: string;
  bumpLast?: boolean;
  content: {
    bumpHeadline?: string;
    ctaButtonText?: string;
    termsLink?: string;
    termsText?: string;
  };
  clientSecret: string;
  paymentIntentId: string;
  products: Product[];
  bumpProducts?: BumpProduct[];
}

const App: React.FC<AppProps> = ({ id }) => {
  const [data, setData] = useState<FetchedData | null>(null);
  const [loading, setLoading] = useState<boolean>(true);  useEffect(() => {
    // Store marketing params as early as possible when App loads
    storeMarketingParamsOnLoad();
    
    const fetchAppProps = async () => {
      setLoading(true);
      try {
        const response = await fetch(
          process.env.REACT_APP_API_URL + `/api/order-form/cart?id=${id}`
        );
        const fetchedData: FetchedData = await response.json();
        setData(fetchedData);
        // console.log(fetchedData);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    fetchAppProps();
  }, [id]);

  if (loading) {
    return <OrderFormSkeleton />;
  }

  if (!data) {
    console.log("no data");
    return <div>Error loading app data.</div>;
  }

  return <OrderForm data={data} componentId={id} />;
};

export default App;
